export const summaryLength = 200
export const fadeSpeed = 0.5
export const paginationNumPageLength = 9
export const paginationCurrentPageLength = 6
export const paginationCurrentPageLengthElseIf = 4
export const paginationCurrentPageLengthElse = 5
export const initialLocation = {
  lat: 47.2380766,
  lng: 4.7772352,
}
export const initialZoom = 14
export const newslettersConfirmation = "newsletter/confirm"
export const payfipConfirmation = "payfip_confirm"
